exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(undefined);
// imports


// module
exports.push([module.id, ".agreement_page {\n  -webkit-box-sizing: border-box;\n  box-sizing: border-box;\n  padding: 0 14px;\n  overflow: auto;\n  height: 100vh;\n  font-family: \"Microsoft YaHei\";\n  color: #000; }\n  .agreement_page h3, .agreement_page h4 {\n    font-weight: 600;\n    margin: 20px 0;\n    color: #000; }\n  .agreement_page h3 {\n    font-size: 18px; }\n  .agreement_page h4 {\n    font-size: 16px; }\n  .agreement_page p {\n    text-indent: 2em;\n    margin: 10px 0;\n    font-size: 15px;\n    line-height: 26px; }\n  .agreement_page .footer {\n    font-size: 13px;\n    color: #808080;\n    text-align: center;\n    line-height: 60px; }\n\n.text-align-center {\n  text-align: center; }\n", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"importLoaders":1}!./node_modules/sass-loader/lib/loader.js!./node_modules/postcss-loader/lib?{"ident":"postcss","plugins":[null,null]}!./src/view/home/agreement.scss
// module id = 868
// module chunks = 0